/** PROBATION-REVIEW-001 P4 — compact reminder history (ledger) for one employee. */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BellRing, ChevronDown } from 'lucide-react';
import { API, h } from './probationApi';
import { formatDateOnlyET } from '../../../../utils/formatters';

const LABEL = { t14: 'T-14', t7: 'T-7', due: 'Due', submitted: 'Submitted → HR', hr_attention: 'HR attention', decision_returned: 'Returned', decision_approved: 'Approved' };
const label = (m) => LABEL[m] || (m.startsWith('overdue_w') ? `Overdue wk ${m.replace('overdue_w', '').replace('_admin', '')}${m.endsWith('_admin') ? ' · Admin' : ''}` : m);
const when = (iso) => (iso ? formatDateOnlyET(iso) : '');

export default function RemindersRow({ employeeId, refreshKey }) {
  const [rows, setRows] = useState([]);
  const [mode, setMode] = useState('');
  const [open, setOpen] = useState(false);
  useEffect(() => {
    axios.get(`${API}/api/hr/probation/employees/${employeeId}/notifications`, { headers: h() })
      .then(r => { setRows(r.data.data || []); setMode(r.data.mode); }).catch(() => setRows([]));
  }, [employeeId, refreshKey]);
  if (!rows.length) return null;
  const sent = rows.filter(r => r.delivered).length;
  return (
    <div className="mt-3 rounded-lg border border-slate-100 bg-slate-50/60" data-testid="probation-reminders">
      <button type="button" className="w-full flex items-center justify-between gap-3 px-3 py-2 text-left" onClick={() => setOpen(o => !o)} data-testid="probation-reminders-toggle">
        <span className="flex items-center gap-2 text-[12.5px] text-slate-700"><BellRing className="h-3.5 w-3.5 text-violet-500" /><span className="font-semibold">{sent}</span> reminder{sent === 1 ? '' : 's'} delivered{rows.length > sent ? ` · ${rows.length - sent} suppressed` : ''}{mode && mode !== 'live' ? <span className="prb-pill prb-slate !h-[18px] !text-[10.5px]">{mode}</span> : null}</span>
        <ChevronDown className={`h-3.5 w-3.5 text-slate-400 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <ul className="px-3 pb-2.5 space-y-1 prb-reveal" data-testid="probation-reminders-list">
          {rows.map(r => (
            <li key={r.key} className="flex items-center justify-between gap-3 text-[12px]" data-testid={`probation-reminder-${r.milestone}`}>
              <span className="flex items-center gap-2 min-w-0"><i className={`prb-dot ${r.delivered ? 'bg-violet-500' : 'bg-slate-300'} !opacity-100`} style={{ width: 6, height: 6, borderRadius: 999 }} /><span className="font-medium text-slate-700 truncate">{label(r.milestone)}</span><span className="text-slate-400 truncate">{r.title}</span></span>
              <span className="text-slate-500 shrink-0">{when(r.updated_at)} · {r.delivered ? r.channels.join(' + ') + (r.email_status === 'failed' ? ' (email failed)' : '') : (r.suppressed_reason || 'suppressed').replace(/_/g, ' ')}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
